import SettingsManager from './SettingsManager';

export default class DataCacheManager {

    constructor() {

        this.settingsManager = new SettingsManager();

        this.initAccount = this.initAccount.bind(this);
        this.initAuth = this.initAuth.bind(this);
        this.initSettings = this.initSettings.bind(this);
        this.clearAll = this.clearAll.bind(this);

        this.blastLocation = [];
        this.blastEmployee = [];
        this.blastEmployeeOverwrite = [];
        this.calendarRatios = {
            wk: 1,
            mth: 1,
            qtr: 1,
            yr: 1
        }
        this.targets = null;
        this.account = this.initAccount();
        this.auth = this.initAuth();
        this.settings = this.initSettings();
    }

    initAccount() {
        let storedAccount = window.localStorage.getItem('zzAccount');
        if (storedAccount === undefined || storedAccount === null) {
            return null;
        } else {
            return JSON.parse(storedAccount);
        }
    }

    initAuth() {
        let storedAuth = window.localStorage.getItem('zzAuth');
        if (storedAuth === undefined || storedAuth === null) {
            return null;
        } else {
            return JSON.parse(storedAuth);
        }
    }

    initSettings() {
        let storedSettings = window.localStorage.getItem('zzSettings');
        if (storedSettings === undefined || storedSettings === null) {
            return this.settingsManager.getDefaultSettings();
        } else {
            let baseSettings = this.settingsManager.getDefaultSettings();
            let overSettings = JSON.parse(storedSettings);

            let keys = Object.keys(overSettings);
            keys.forEach(key => {
                baseSettings[key] = overSettings[key];
            });

            return baseSettings;
        }
    }

    clearAll() {
        this.blastLocation = [];
        this.blastEmployee = [];
        this.blastEmployeeOverwrite = [];
        this.targets = null;
        this.account = null;
        this.auth = null;
        this.settings = this.settingsManager.getDefaultSettings();

        window.localStorage.removeItem('zzAccount');
        window.localStorage.removeItem('zzAuth');
        window.localStorage.removeItem('zzSettings');
    }
}